type TrackLike = {
  id: string;
  name: string;
  artists: { name: string }[];
};

export function trackDedupeKey(t: TrackLike): string {
  const name = (t.name || "").trim().toLowerCase();
  const artists = (t.artists || [])
    .map((a) => (a?.name || "").trim().toLowerCase())
    .join("|");
  if (!name || !artists) return `id:${t.id}`;
  return `${name}::${artists}`;
}

export function dedupeTracks<T extends TrackLike>(tracks: T[]): T[] {
  const seen = new Set<string>();
  const out: T[] = [];
  for (const t of tracks) {
    const key = trackDedupeKey(t);
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(t);
  }
  return out;
}
